// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"648":"a26a8351","722":"3e15e9be"}[chunkId] + ".chunk.js";
};